@let section = sectionSg();
@let isSectionExpanded = isSectionExpandedSg();

@if (sectionScenariosSg().length > 0) {
  <div class="atn-scenario-dropdown-overlay-section__divider">
    <div class="atn-scenario-dropdown-overlay-section__divider-header">
      <span class="atn-scenario-dropdown-overlay-section__divider-icon">
        <i class="atn-icon atn-blue {{ section.icon }}"></i>
      </span>
      <span class="atn-scenario-dropdown-overlay-section__divider-name">
        {{ section.name }}
      </span>
    </div>
    <div class="atn-scenario-dropdown-overlay-section__divider-collapse">
      <i
        class="atn-icon atn-blue"
        [class.atn-angle-down]="isSectionExpanded"
        [class.atn-angle-left]="!isSectionExpanded"
        (click)="toggleSectionBtnClickHandler()"
      ></i>
    </div>
  </div>
}
<!-- Display scenarios if section is expanded -->
@if (isSectionExpanded) {
  <div class="atn-scenario-dropdown-overlay-section__body">
    @for (scenario of section.scenarios; track $index) {
      <atn-scenario-dropdown-overlay-section-scenario
        [scenario]="scenario"
        data-test-id="existing-scenarios"
      />
    }
  </div>
}
